// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__qew9-","left":"InfoRow_left__3kklT"};